import BaseApiCall from "./BaseApiCall";

export const loadEntries = async (dateRange) => {
  try {
    const payload = {
      startDate: `${dateRange[0].startDate.toISOString().split("T")[0]}T00:00:00`,
      endDate: `${dateRange[0].endDate.toISOString().split("T")[0]}T23:59:59`,
    };
    const response = await BaseApiCall.post('/report/entries', payload);
    return response.data;
  } catch (error) {
    console.error('Error loading report entries:', error.message);
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
    }
    throw error;
  }
};

export const loadEntriesPerHead = async (dateRange) => {
  try {
    const payload = {
      startDate: `${dateRange[0].startDate.toISOString().split("T")[0]}T00:00:00`,
      endDate: `${dateRange[0].endDate.toISOString().split("T")[0]}T23:59:59`,
    };
    const response = await BaseApiCall.post('/report/entries-per-head', payload);
    return response.data;
  } catch (error) {
    console.error('Error loading report entries:', error.message);
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
    }
    throw error;
  }
};
